import { render, staticRenderFns } from "./getPwd.vue?vue&type=template&id=580189c1&scoped=true&"
import script from "./getPwd.vue?vue&type=script&lang=js&"
export * from "./getPwd.vue?vue&type=script&lang=js&"
import style0 from "./getPwd.vue?vue&type=style&index=0&id=580189c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580189c1",
  null
  
)

export default component.exports